<template>
  <DialogPortal>
    <div class="dialog-container">
      <DialogBlock v-for="dialog in activeDialogs" :key="dialog.id" :data="dialog" />
    </div>
  </DialogPortal>
</template>

<script setup lang="ts">
import { useAppStore } from '@/stores/app'
import DialogPortal from 'primevue/portal'
import { computed } from 'vue'
import DialogBlock from './DialogBlock.vue'

const appStore = useAppStore()

const activeDialogs = computed(() => {
  return appStore.dialogIds.map(id => appStore.dialogs[id]).filter(Boolean)
})
</script>

<style scoped lang="scss">
.dialog-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 1000;

  // Все диалоги внутри контейнера получают pointer-events
  &>* {
    pointer-events: all;
  }
}

// Затемнение фона для модальных окон
:deep(.p-dialog-mask) {
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2px);
}
</style>
